import React from 'react';
import { hrefForSameSiteAsset } from '../productMediaUtils';

/**
 * Product/category image from DB path only. Renders a neutral placeholder when missing.
 */
export default function CatalogImage({ src, alt = '', className = '', loading = 'lazy', sizes, style }) {
  const path = String(src || '').trim();
  if (!path) {
    return (
      <div
        className={`catalog-media-placeholder ${className}`.trim()}
        style={style}
        role="img"
        aria-label={alt || 'No image'}
      />
    );
  }
  return (
    <img
      src={hrefForSameSiteAsset(path)}
      alt={alt}
      className={className}
      loading={loading}
      sizes={sizes}
      style={style}
    />
  );
}
